/* eslint-disable camelcase */

import axios from 'axios';
import type { CamelCasedProperties } from 'type-fest';
import type { Organization as OrganizationModel, OrganizationDto } from '@hotjar/organization';
import { mapOrganizationDtoToModel } from '@hotjar/organization';

const API_ROOT = '/api/v1/accounts/';

interface AddOrganizationResponseDTO {
  organization: {
    name: string;
    id: number;
    account_id: number;
  };
  organizations: OrganizationDto[];
  success: boolean;
  error?: Error;
}

export interface AddOrganizationResponse {
  organization: CamelCasedProperties<AddOrganizationResponseDTO['organization']>;
  organizations: OrganizationModel[];
  success: boolean;
  error?: Error;
}

export async function addOrganization(
  accountId: number,
  name: string,
): Promise<AddOrganizationResponse> {
  const response = await axios.post<AddOrganizationResponseDTO>(
    `${API_ROOT}${accountId}/organizations`,
    {
      action: 'add_organization',
      name,
    },
  );

  if (!response.data.success) {
    throw new Error();
  }

  return {
    ...response.data,
    organization: {
      name: response.data.organization.name,
      id: response.data.organization.id,
      accountId: response.data.organization.account_id,
    },
    organizations: response.data.organizations.map(mapOrganizationDtoToModel),
  };
}
